import { en } from './en'
import { zh } from './zh'

export type Lang = 'en' | 'zh'
export type TranslationKey = keyof typeof en

const DICTS = { en, zh } as const

/**
 * Both languages must define the same keys. Missing copy should be caught in
 * development, not discovered by a member seeing `guest.eventsTitle` on screen.
 */
export function missingKeys(): { inZh: string[]; inEn: string[] } {
  const enKeys = Object.keys(en)
  const zhKeys = Object.keys(zh)
  return {
    inZh: enKeys.filter((k) => !zhKeys.includes(k)),
    inEn: zhKeys.filter((k) => !enKeys.includes(k))
  }
}

/** A bilingual value from the API: a plain string, or { en, zh }. */
export type Localised = string | { en?: string; zh?: string } | null | undefined

export function localise(value: Localised, lang: Lang): string {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  return value[lang] || value.en || value.zh || ''
}

export function createTranslator(lang: Lang) {
  const dict = DICTS[lang] as Record<string, string>
  const fallback = en as Record<string, string>
  return {
    t: (key: string): string => dict[key] ?? fallback[key] ?? key,
    L: (value: Localised) => localise(value, lang),
    lang
  }
}

export { en, zh }
